// ViewAgreement.jsx - Componente actualizado
const ViewAgreement = ({ agreement, onClose }) => {
  return (
    <>
      <div className="relative w-full">
        <div className="w-full aspect-video bg-gray-100 overflow-hidden">
          {agreement.image ? (
            <img
              src={agreement.image}
              alt="Imagen actual"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <div className="flex items-center justify-center h-full bg-gradient-to-r from-gray-100 to-gray-200">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          )}
        </div>

        {/* Título sobre la imagen */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
          <h2 className="text-3xl font-bold text-white">
            {agreement.title}
          </h2>
        </div>
      </div>

      <div className="px-4 sm:px-6 py-6">
  <div className="max-w-4xl mx-auto bg-gray-50 p-6 rounded-xl border border-gray-200 shadow-sm space-y-6 text-gray-800">
    <h3 className="text-xl font-bold border-b border-gray-200 pb-3">Información del Convenio</h3>

    {/* Empresa */}
    <div>
      <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">Empresa</h4>
      <p className="text-base font-medium">{agreement.business_name || 'No especificada'}</p>
    </div>

    {/* Contacto */}
    <div>
      <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">Contacto</h4>
      {agreement.contact && agreement.contact.includes('@') ? (
        <a
          href={`mailto:${agreement.contact}`}
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors font-medium break-all"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          {agreement.contact}
        </a>
      ) : (
        <p className="text-gray-600">{agreement.contact || 'No disponible'}</p>
      )}
    </div>

    {/* Descripción */}
    {agreement.description && (
      <div className="pt-2 text-justify whitespace-pre-line leading-relaxed text-gray-700">
        {agreement.description}
      </div>
    )}

    {/* Botón cerrar */}
    <div className="flex justify-end pt-4">
      <button
        onClick={onClose}
        className="px-6 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg transition-all border border-gray-300"
      >
        Cerrar
      </button>
    </div>
  </div>
</div>

    </>
  );
};

export default ViewAgreement;
